import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
type RevealProps = {
  children: React.ReactNode;
  delay?: number;
  className?: string;
  as?: 'div' | 'li' | 'span';
};
export function Reveal({
  children,
  delay = 0,
  className,
  as = 'div'
}: RevealProps) {
  const reduced = useReducedMotion();
  const MotionTag = motion[as];
  if (reduced) {
    const Tag = as;
    return <Tag className={className} data-id="element-253" data-mp="2jqg9jvetyw7z">{children}</Tag>;
  }
  return <MotionTag className={className} initial={{
    opacity: 0,
    y: 18
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-12% 0px -12% 0px'
  }} transition={{
    duration: 0.28,
    delay,
    ease: [0.23, 1, 0.32, 1]
  }} data-id="element-254" data-mp="2js161qkpgp8h">
      {children}
    </MotionTag>;
}